import Constant from '@/common/constant/Constant';
import Utils from '@/common/utils/utils';
import LoadingPanel from '@/component/common/LoadingPanel';
import { corporationAtom } from '@/state/atom/corporationAtom';
import { panelSettingAtom } from '@/state/atom/panelAtom';
import { projectInuseDetailAtom } from '@/state/atom/projectAtom';
import {
    helpdeskTicketListDefaultDrillDownDataAtom,
    helpdeskTicketListDefaultSelectedOptionAtom,
    helpdeskTicketListDrillDownDataAtom,
    helpdeskTicketListIsLoadingDrillDownDataAtom,
    helpdeskTicketListViewStructureAtom,
    helpdeskTicketListVisibilityAtom,
    helpdeskTicketNotIncludeAtom,
    helpdeskTicketSearchTagSuggestAtom,
    helpdeskTicketContainAnyAtom,
    helpdeskTicketLastUserActionAtom,
} from '@/state/atom/ticketAtom';
import { getUserListByProjectAtom, userAtom } from '@/state/atom/userAtom';
import { setPanelSelector, triggerReloadTicketListByPanelType } from '@/state/selector/panelSelector';
import { isManagerByProjectInuseSelector } from '@/state/selector/projectSelector';
import { Tooltip, Popover } from '@material-ui/core';
import trI18n from '@/common/utils/trI18n';
import { tr } from '@/common/utils/tr';
import { useTranslationSubscription } from '@/hooks/useTranslation';
import React, { useEffect, useRef, useState, useMemo } from 'react';
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import {
    autoReloadTicketList,
    getHelpdeskDrilldownDataAndSugguestionList,
    getProjectMemberList,
    getVisibleWidth,
    handleSearchTicketList
} from '../handler/HelpDeskTicketListHandler';
import {
    getDefaultDrilldownData,
    getHelpDeskListViews,
    onChangeVisibilitySetting
} from '../handler/HelpDeskViewHandler';
import {
    getDrilldownDataSelected,
    getDrilldownItemDataSelected
} from '../handler/KnowledgeTicketHandler';
import { isOpenButtonCreateTicket } from '../handler/TicketListHandler';
import ListTicket from '../List';
import '../Ticket.css';
import './HelpDeskTicketList.css';
import { DialogNoticeViewChanged } from './views/DialogNoticeViewChanged';
import { DialogViewNameError } from './views/DialogViewNameError';
import ViewHelpDeskList from './views/ViewHelpDeskList';
import DataChangePleaseReloadModal from '@/component/common/modal/DataChangePleaseReloadModal';
import SeemoreViewHelpdeskList from '@/component/ticketList/helpdeskSide/views/SeemoreViewHelpdeskList';
import AddViewHelpdeskList from '@/component/ticketList/helpdeskSide/views/AddViewHelpdeskList';
import HelpdeskListDrilldownSelected from '@/component/ticketList/helpdeskSide/HelpdeskListDrilldownSelected';
import HelpdeskListSearchInput from '@/component/ticketList/helpdeskSide/HelpdeskListSearchInput';
import '@/component/common/layout/tabs/TabsInfo.css';
import LogKibanaConstant from '@/common/constant/LogKibanaConstant';
import BulkActionHelpDesk from './elements/BulkActionHelpDesk';
import ConfirmDialog from '@/common/dialog/ConfirmDialog';
import RenderTagFieldInForm from '@/component/ticketKnowledge/elements/RenderTagFieldInForm';
import RenderExportMenu from '@/component/ticketKnowledge/elements/RenderExportMenu';
import { getAllBookmarkUserCanUse, getListTagFieldOfForm } from '../../ticketKnowledge/handler/ListTicketKnowledgeHandler';
import PhoneSearchPopoverV2 from '@/component/common/PhoneSearchPopoverV2';
import { useOutboundCall } from '@/hooks/useOutboundCall';
import { voiceStatusAtom, voiceCallAiTrainingAtom } from '@/state/atom/voiceCallAtom';
import * as openAIWebRTCService from '@/service/openAIWebRTCService';
import { validateTrainingTelephonePermission } from '@/service/phoneContactService';
import { openTelephoneTicketPanel } from '@/component/telephoneAgent/handler/TelephoneTicketPanelHandler';
import { useSnackbar } from 'notistack';
import { buildSnackbarMessage } from '@/component/common/SnackbarMessage';
import ListTicketOnDemandControl from '@/component/multiLanguage/elements/ListTicketOnDemandControl';
import useListTicketOnDemand from '@/component/multiLanguage/hooks/useListTicketOnDemand';

export default function HelpDeskTicketList(props) {
    // Re-render when the translation dictionary loads/extends so tr() text updates.
    useTranslationSubscription();
    const { API } = {...props};

    // Add new panel
    const addNewPanel = useSetRecoilState(setPanelSelector);
    const reloadTicketListByPanelType = useSetRecoilState(triggerReloadTicketListByPanelType);

    const [isLoading, setIsLoading] = useState(false);
    const [isLoadingView, setIsLoadingView] = useState(false);
    // common userDetail state
    const userDetail = useRecoilValue(userAtom);
    // common corporationDetail state
    const corporationDetail = useRecoilValue(corporationAtom);
    // common projectInuse state
    const projectInuseDetail = useRecoilValue(projectInuseDetailAtom);

    const [ticketList, setTicketList] = useState([]);
    const [currentSearchParams, setCurrentSearchParams] = useState({});
    const [contractType, setContractType] = useState(1);

    const isProjectManager = useRecoilValue(isManagerByProjectInuseSelector);

    const [viewSelected, setViewSelected] = useState({});
    const [listView, setListView] = useState([]);
    const [openListViewHide, setOpenListViewHide] = useState(false);
    const [isOpenDialogViewNameError, setIsOpenDialogViewNameError] = useState(false);
    const [isOpenDialogViewChanged, setIsOpenDialogViewChanged] = useState(false);
    const [viewNameErrorType, setViewNameErrorType] = useState('');

    // view / keyword
    const [viewStructure, setViewStructure] = useRecoilState(helpdeskTicketListViewStructureAtom);
    const [keywordSearch, setKeywordSearch] = useState(viewStructure.keyword);
    const [triggerSearch, setTriggerSearch] = useState('');

    const inputViewNameRef = useRef();
    const inputKeyWordRef = useRef();
    const prevTriggerReloadRef = useRef(props?.triggerReload);

    // DrillDown data
    const [isLoadingDrillDown, setIsLoadingDrillDown] = useRecoilState(
        helpdeskTicketListIsLoadingDrillDownDataAtom
    );
    const [drillDownData, setDrillDownData] = useRecoilState(helpdeskTicketListDrillDownDataAtom);
    const [drilldownDataSelected, setDrillDownDataSelected] = useState([]);
    const [sugguestionList, setSugguestionList] = useState([]);
    const setSettingSlideRecoilState = useSetRecoilState(panelSettingAtom);
    const [defaultDrillDownData, setDefaultDrillDownData] = useRecoilState(
        helpdeskTicketListDefaultDrillDownDataAtom
    );

    // Search option
    const [optionSearchTime, setOptionSearchTime] = useState('');
    const setDefaultSelectedOption = useSetRecoilState(helpdeskTicketListDefaultSelectedOptionAtom);
    const [isInitView, setIsInitView] = useState(true);

    const helpDeskVisibilityInState = useRecoilValue(helpdeskTicketListVisibilityAtom);
    const [isOpenModalReloadPage, setIsOpenModalReloadPage] = useState(false);

    // Assignee
    const userListRecoilValue = useRecoilValue(getUserListByProjectAtom);
    const [projectUserList, setProjectUserList] = useState([]);

    // common fieldList state

    const [triggerInterval, setTriggerInterval] = useState('');
    const nodeListView = document.querySelectorAll('.item-helpdesk');
    const element = document.querySelector('#container');

    const [lastedCountList, setLastedCountList] = useState(0);
    const [fromTicket, setFromTicket] = useState(0);
    const [totalTickets, setTotalTickets] = useState(0);
    const [removedTagItem, setRemovedTagItem] = useState({});
    const [lastUserAction, setLastUserAction] = useRecoilState(helpdeskTicketLastUserActionAtom)
    const [searchContentType, setSearchContentType] = useState(LogKibanaConstant.CONTENT_TYPES_TICKET.QA)
    const [searchTagSuggest, setSearchTagSuggest] = useRecoilState(helpdeskTicketSearchTagSuggestAtom)
    const [searchContainAny, setSearchContainAny] = useRecoilState(helpdeskTicketContainAnyAtom);
    const [searchNotInclude, setSearchNotInclude] = useRecoilState(helpdeskTicketNotIncludeAtom);
    const [isShowDialogNotiLimit, setIsShowDialogNotiLimit] = useState(false);
    const [msgInProcessingIcon, setMsgInProcessingIcon] = useState("");
    const [isShowEditTagFields,setIsShowEditTagField] = useState(false);
    const [listTagFieldOfForm,setListTagFieldOfForm] = useState([]);
    
    // Phone Search Popover state
    const [phoneSearchAnchorEl, setPhoneSearchAnchorEl] = useState(null);
    const isPhoneSearchOpen = Boolean(phoneSearchAnchorEl);
    const [voiceStatus, setVoiceStatus] = useRecoilState(voiceStatusAtom);
    
    const isCannotMakeCall = useMemo(() => {
        return voiceStatus !== Constant.PHONE_AVAILABILITY.READY;
    }, [voiceStatus]);

    // Voice call hook
    const { initiateCall } = useOutboundCall();
    const setVoiceCallAiTraining = useSetRecoilState(voiceCallAiTrainingAtom);
    const { enqueueSnackbar } = useSnackbar();

    const [selectedFormId, setSelectedFormId] = useState('')
    const [loadingBulkItemListTagField,setLoadingBulkItemListTagField] = useState(false);
    const [isShowDialogReload,setIsShowDialogReload] = useState(false)
    const [formTypePopover, setFormTypePopover] = useState(null);
    const isOpenFormTypePopover = Boolean(formTypePopover);
    const [isShowExportMenu, setIsShowExportMenu] = useState(false);
    const [isOpenDialogConfirm, setIsOpenDialogConfirm] = useState({
        status: false,
        action: '',
        params: {},
    });

    const lastUserActionRef = useRef(lastUserAction);
    const lastSearchTagSuggestRef = useRef(searchTagSuggest);

    const clearMemoryLoadTicketList = () => {
        setIsLoading(false);
        setIsLoadingView(false);
        setTicketList([]);
        setDrillDownDataSelected([]);
        setDrillDownData([]);
        setSugguestionList([]);
        setDefaultDrillDownData([]);
        setProjectUserList([]);
        setViewSelected({});
        setListView([]);
    }

    const propsForListTicket = { ...props };
    delete propsForListTicket.corporationDetail;
    delete propsForListTicket.projectDetail;
    delete propsForListTicket.userDetail;
    delete propsForListTicket.setUserDetail;

    useEffect(() => {
        const fields = viewStructure.fields;
        const isSelectForm = fields?.find(field => {
           return !Utils.isEmptyString(field.form)
        });
        if(!isSelectForm){
            setIsShowEditTagField(false)
            setIsShowExportMenu(false)
        }
    },[viewStructure]);

    useEffect(() => {
        lastUserActionRef.current = lastUserAction;
    }, [lastUserAction]);

    useEffect(() => {
        lastSearchTagSuggestRef.current = searchTagSuggest;
    }, [searchTagSuggest]);

    // On-demand list translation (MLT-001-F4): keep state in sync + auto-translate new records.
    useListTicketOnDemand({
        panelType: Constant.PANEL_TYPE.HELPDESK_TICKET_LIST,
        viewKey: viewSelected?.id,
        items: ticketList,
        setIsOpenModalReloadPage
    });


    // update ticket list
    // init subscription ticket
    useEffect(() => {
        // Off interval in local
        if (process.env.NODE_ENV === 'development') return;

        let appDomain = process.env.REACT_APP_DOMAIN_NAME || '';
        let timeInterval = 60000;
        if (appDomain && appDomain.includes('dbdesk-test.ominext.dev')) {
            timeInterval = timeInterval*10;
        }
        const reloadTicketLists = setInterval(setGetListInterval, timeInterval);
        window.reloadTicketLists = reloadTicketLists;

        return () => {
            clearInterval(reloadTicketLists)
        }
    }, []);

    useEffect(() => {
        const controller1 = new AbortController();
        setIsLoadingView(true);

        getHelpDeskListViews(
            API,
            setIsInitView,
            setViewSelected,
            setViewStructure,
            setListView,
            userDetail.id,
            projectInuseDetail.id,
            Constant.VISIBILITY_SETTING_TYPE.PRIVATE,
            Constant.DEFINITION_VIEW.HELPDESK,
            {}
        ).then((initListViews) => {
            if (!initListViews || Utils.isEmptyArray(initListViews)) return;
            setIsLoadingView(false);

            let newStructure = {
                ...JSON.parse(initListViews[0].structure),
                visibility: Constant.VISIBILITY_SETTING_TYPE.PRIVATE
            };

            getDefaultDrilldownData(
                API,
                Constant.VISIBILITY_SETTING_TYPE.PRIVATE,
                newStructure,
                corporationDetail.id,
                projectInuseDetail.id,
                userDetail.id,
                setDefaultDrillDownData
            );
        });

        return () => {
            controller1.abort();
        }
    }, [projectInuseDetail]);

    const setGetListInterval = () => {
        // trick
        setTriggerInterval(Date.now().toString());
    };

    const initGetTicketLists = async (isRequiredReload) => {
        const existsView = listView.some(item => item.id === viewSelected.id);
        if ( Utils.isEmptyObject(projectInuseDetail) || !existsView ) return;
        if (!isRequiredReload && isInitView) return;

        const promiseGetDrilldownDataAndSugguestionList = async () => {
            setIsLoadingDrillDown(true);
            getHelpdeskDrilldownDataAndSugguestionList(
                API,
                viewStructure,
                corporationDetail.id,
                projectInuseDetail.id,
                userDetail.id,
                defaultDrillDownData,
                {setCurrentSearchParams}
            )
                .then(drillDownDataResult => {
                    setDrillDownData(drillDownDataResult.drillDownData);
                    setSugguestionList(drillDownDataResult.sugguestionList);
                })
                .catch((err) => {
                    console.log('getDrilldownDataAndSugguestionList err: ', err)
                })
                .finally(() => {
                    setIsLoadingDrillDown(false);
                });
        }

        const triggerLoading = true;
        getTicketLists(triggerLoading);

        await Promise.all([
            promiseGetDrilldownDataAndSugguestionList(),
            getProjectMemberList(userListRecoilValue, setProjectUserList, projectInuseDetail.id)
        ]);
    };

    const formIdSearchConditionFilterBy = () => {
        const fields = !Utils.isEmptyArray(viewStructure?.fields) ? viewStructure?.fields : [];
        const indexOfSelectedForm = fields?.find(field => {
            return !Utils.isEmptyString(field?.form)
        });

        return indexOfSelectedForm && indexOfSelectedForm['form'] ? indexOfSelectedForm['form'] : '';
    }

     // Check convertPdf in CorpRoot by selectedProject
     useEffect(() => {
        const controller9 = new AbortController();
        initDataForBulkActionTagField()
        
        return () => {
            controller9.abort();
        }
    }, [drillDownData, viewStructure?.fields?.length]);

    const initDataForBulkActionTagField = async () => {

        let allTagFieldForBulkAction = [];
        let promiseGetData = [getAllBookmarkUserCanUse(userDetail.id, projectInuseDetail.id, Constant.BOOKMARK_TARGET_TYPE.TICKET)];
        setLoadingBulkItemListTagField(true);

        let selectedForm = drillDownData?.find(drillDownDataItem => {
            return drillDownDataItem.id === Constant.DRILLDOWN_TYPE_TEXT.FORM;
        });

        const structure = Utils.convertJSONDataToObject(viewSelected.structure);
        const ticketProperty = structure?.ticketProperty;

        if (!Utils.isEmptyObject(selectedForm) && formIdSearchConditionFilterBy() && ticketProperty !== Constant.TICKET_PROPERTY.ARCHIVE) {
            const child = selectedForm.child;
            const formId = child[0]?.id;
            if (formId !== selectedFormId) {
                setSelectedFormId(formId);
            }
            if (!Utils.isEmptyString(formId)) {
                promiseGetData.push(
                    getListTagFieldOfForm({
                        formId,
                        userDetail,
                        projectInuseDetail,
                        corporationDetail,
                        setSelectedFilterForm: () => {},
                        affiliationProjectId: projectInuseDetail.id,
                        isProjectManager,
                        viewStructure
                    })
                );
            } 
        }

        let getDataTagResponse = await Promise.all(promiseGetData);

        let allBookmark = getDataTagResponse[0];
        if (!Utils.isEmptyArray(getDataTagResponse) && getDataTagResponse.length === 2) {
            let listTagField = getDataTagResponse[1];
            if (!Utils.isEmptyArray(listTagField)) {
                listTagField.forEach(tagField => {
                    let fieldata = {
                        ...tagField,
                        name: Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, tagField.name)
                    };
                    allTagFieldForBulkAction.push(fieldata);
                })
            }
        }

        if (!Utils.isEmptyArray(allBookmark)) {
            allBookmark = Utils.sortListByNameDictionaryASC(allBookmark);
            allTagFieldForBulkAction.push({
                id: [Constant.FORMAT_OPTION_SEARCH.PRIVATE_BOOKMARK, Constant.FORMAT_OPTION_SEARCH.SHARED_BOOKMARK],
                name: trI18n('BOOKMARK_TAG'),
                listItem: allBookmark,
                isBookmark: true
            })
        }

        setListTagFieldOfForm([...allTagFieldForBulkAction]);

        setLoadingBulkItemListTagField(false);
    }

    // todo: hot fix for hidden loading
    useEffect(() => {
        const controller2 = new AbortController();
        if (triggerInterval) {
            let argsReloadTicketList = {
                API,
                corporationId: corporationDetail.id,
                projectId: projectInuseDetail.id,
                userId: userDetail.id,
                viewStructure,
                setViewStructure,
                setOptionSearchTime,
                defaultDrillDownData,
                inputKeyWordRef,
                lastedCountList,
                setLastedCountList,
                fromTicket,
                setFromTicket,
                setIsLoading,
                keywordSearch,
                setKeywordSearch,
                ticketList,
                setTicketList,
                setDrillDownDataSelected,
                setDrillDownData,
                setSugguestionList,
                setDefaultDrillDownData,
                setProjectUserList,
                setTotalTickets,
                userDetail
            };
            autoReloadTicketList(argsReloadTicketList);
        }

        return () => {
            controller2.abort();
        }
    }, [triggerInterval]);

    useEffect(() => {
        setIsShowEditTagField(false)
        setIsShowExportMenu(false)

        const controller4 = new AbortController();
        if (viewSelected && viewSelected.structure) {
            let newViewStructure = Utils.convertJSONDataToObject(viewSelected.structure);
            getDrilldownItemDataSelected(API, newViewStructure, true, false).then(drillDownDataRes => {
                setDefaultSelectedOption(
                    !Utils.isEmptyArray(drillDownDataRes) ? drillDownDataRes : []
                );
            });
            if (lastUserAction !== LogKibanaConstant.SEARCH_ACTION.VIEW_CHANGE) {
                lastUserActionRef.current = LogKibanaConstant.SEARCH_ACTION.VIEW_CHANGE;
                lastSearchTagSuggestRef.current = [];
                setLastUserAction(LogKibanaConstant.SEARCH_ACTION.VIEW_CHANGE);
                setSearchTagSuggest([]);
            }
        }

        return () => {
            controller4.abort();
        }
    }, [viewSelected]);

    useEffect(() => {
        const controller3 = new AbortController();

        let isRequiredReload = false;

        const triggerReloadValue = props?.triggerReload;
        const isTriggerReloadChanged = triggerReloadValue !== prevTriggerReloadRef.current;
        prevTriggerReloadRef.current = triggerReloadValue;

        if (isTriggerReloadChanged && triggerReloadValue) {
            // Format: "viewType_<viewType>:triggerId_<uuid>" or "triggerId_<uuid>"
            const hasViewType = triggerReloadValue.startsWith('viewType_');
            if (hasViewType) {
                const triggerViewType = triggerReloadValue.split(':')[0].replace('viewType_', '');
                const viewOfStructure = Utils.convertJSONDataToObject(viewSelected?.structure);
                const ticketProperty = viewOfStructure?.ticketProperty;
                if (triggerViewType !== ticketProperty) {
                    return;
                }
            }
            isRequiredReload = true;
        }


        initGetTicketLists(isRequiredReload);

        return () => {
            controller3.abort();
        }
    }, [
            props.triggerReload,
            projectInuseDetail.id,
            triggerSearch,
            viewStructure.fields.length,
            viewStructure.privateBookmark?.length,
            viewStructure.sharedBookmark?.length,
            viewStructure.statusFields?.length,
            viewStructure.tagFields?.length,
            viewStructure.keyword,
            viewStructure.visibility,
            viewStructure.ticketProperty,
            isInitView,
            viewSelected.id
    ]);

    useEffect(() => {
        setContractType(corporationDetail.contractType);

        return () => {
            clearMemoryLoadTicketList();
        }
    }, []);

    useEffect(() => {
        setIsShowEditTagField(false)
        setIsShowExportMenu(false)

        const controller5 = new AbortController();
        if (isInitView || isLoadingView) return;
        onChangeVisibilitySetting(
            API,
            setIsInitView,
            setViewSelected,
            viewStructure,
            setViewStructure,
            setListView,
            userDetail.id,
            projectInuseDetail.id,
            setIsLoadingView,
            helpDeskVisibilityInState,
            corporationDetail.id,
            setDefaultDrillDownData
        );
        // setGetListInterval();

        return () => {
            controller5.abort();
        }
    }, [helpDeskVisibilityInState]);

    const getTicketLists = async loading => {
        if (loading) setIsLoading(true);
        handleSearchTicketList(
            API,
            setTotalTickets,
            corporationDetail.id,
            projectInuseDetail.id,
            userDetail.id,
            viewStructure,
            setViewStructure,
            setOptionSearchTime,
            defaultDrillDownData,
            inputKeyWordRef,
            viewStructure.visibility ? viewStructure.visibility : helpDeskVisibilityInState,
            0,
            Constant.TICKET_LIST_PAGINATION_DEFAULT_RECORD,
            lastUserActionRef.current,
            corporationDetail,
            projectInuseDetail,
            userDetail,
            searchContentType,
            lastSearchTagSuggestRef.current,
            searchContainAny,
            searchNotInclude,
            viewSelected,
            removedTagItem,
            setRemovedTagItem,
            setSearchTagSuggest
        )
            .then(async ticketListResult => {
                setLastedCountList(ticketListResult.length);
                setFromTicket(0);
                // Update keyword search
                if (viewStructure.keyword !== keywordSearch) {
                    setKeywordSearch(viewStructure.keyword);
                }
                setTicketList(ticketListResult);
                await getDrilldownDataSelected(API, viewStructure, setDrillDownDataSelected, true, false);
                setIsLoading(false);
            })
            .catch(error => {
                console.log('handleSearchTicketList err: ', error)
                setTicketList([]);
                setIsLoading(false);
            });
    };

    const handleAddPanel = async (e, selectedTicketType) => {
        // console.log('177259 handleAddPanel', props)
        addNewPanel( {
            type: Constant.PANEL_TYPE.HELPDESK_TICKET_DETAIL,
            tabId: `HELPDESK_NEW_TICKET_TAB_${Date.now().toString()}`,
            props,
            selectedTicketType
        });
        setFormTypePopover(null)
    };

    const handleOptionsTicketTypeToCreate = (e) => {
        if (Utils.isPublicOffDeskOff(projectInuseDetail)) {
            return handleAddPanel(e, Constant.HELPDESK_CREATE_TICKET_TYPE.TASK);
        }
        setFormTypePopover(e.currentTarget)
    }
    
    const renderContentTab = () => {
        return (
            <div className="content-tab-body">
                <HelpdeskListSearchInput
                    API={API}
                    inputKeyWordRef={inputKeyWordRef}
                    keywordSearch={keywordSearch}
                    setKeywordSearch={setKeywordSearch}
                    sugguestionList={sugguestionList}
                    viewStructure={viewStructure}
                    setViewStructure={setViewStructure}
                    setTriggerSearch={setTriggerSearch}
                    userDetail={userDetail}
                    projectInuseDetail={projectInuseDetail}
                    corporationDetail={corporationDetail}
                    addNewPanel={addNewPanel}
                    panelId={props.panelId}
                    lastUserAction={lastUserAction}
                    setLastUserAction={setLastUserAction}
                    setSearchTagSuggest={setSearchTagSuggest}
                    searchTagSuggest={searchTagSuggest}
                />

                <HelpdeskListDrilldownSelected
                    drilldownDataSelected={drilldownDataSelected}
                    optionSearchTime={optionSearchTime}
                    setOptionSearchTime={setOptionSearchTime}
                    viewStructure={viewStructure}
                    setViewStructure={setViewStructure}
                    setTriggerSearch={setTriggerSearch}
                    setLastUserAction={setLastUserAction}
                    setRemovedTagItem={setRemovedTagItem}
                    projectInuseDetail={projectInuseDetail}
                    userDetail={userDetail}
                />

                <div className='ticket-list-toolbar'>
                    {/* Search Result */}
                    <span className="option-name">
                        <strong>{tr('検索結果：')}{totalTickets}{tr('件')}</strong>
                    </span>

                    {/* List Ticket OnDemand */}
                    <ListTicketOnDemandControl
                        panelType={Constant.PANEL_TYPE.HELPDESK_TICKET_LIST}
                        viewKey={viewSelected?.id}
                        className="list-ticket-ondemand-translation--toolbar-right"
                        totalTickets={totalTickets}
                    />

                    {/* Helpdesk BulkAction */}
                    <BulkActionHelpDesk
                        listTicketHelpDesk={ticketList}
                        totalTickets={totalTickets}
                        viewSelected={viewSelected}
                        selectedProject={projectInuseDetail}
                        onSubmitSearchListHelpDesk={() => {
                            setTriggerSearch(Date.now().toString());
                        }}
                        currentSearchParams={currentSearchParams}
                        viewStructure={viewStructure}
                        drillDownData={drillDownData}
                        setIsShowDialogNotiLimit={setIsShowDialogNotiLimit}
                        msgInProcessingIcon={msgInProcessingIcon}
                        setMsgInProcessingIcon={setMsgInProcessingIcon}
                        setIsShowEditTagField={setIsShowEditTagField}
                        setIsShowExportMenu = {setIsShowExportMenu}
                        isOpenDialogConfirm={isOpenDialogConfirm}
                        setIsOpenDialogConfirm={setIsOpenDialogConfirm}
                    />
                </div>

                {isShowEditTagFields && (
                    <RenderTagFieldInForm
                        setIsShowEditTagField={setIsShowEditTagField}
                        listTagFieldOfForm={listTagFieldOfForm}
                        drillDownData={drillDownData}
                        totalTickets={totalTickets}
                        currentSearchParams={currentSearchParams}
                        setIsShowDialogReload = {setIsShowDialogReload}
                        setIsShowDialogNotiLimit={setIsShowDialogNotiLimit}
                        msgInProcessingIcon={msgInProcessingIcon}
                        setMsgInProcessingIcon={setMsgInProcessingIcon}
                        loadingBulkItemListTagField={loadingBulkItemListTagField}
                        action={Constant.BULK_ACTION.HELPDESK_EDIT_TAG_FIELD}
                        selectedFormId={{selectedFormId}}
                    />
                )}
                {isShowExportMenu && (
                    <RenderExportMenu
                        action={Constant.BULK_ACTION.HELPDESK_EXPORT_CSV}
                        setIsShowExportMenu={setIsShowExportMenu}
                        setIsOpenDialogConfirm={setIsOpenDialogConfirm}
                        currentSearchParams={currentSearchParams}
                    />
                )}
                <ConfirmDialog
                    isOpen={isShowDialogReload}
                    msgConfirm={trI18n('COMMSG030')}
                    okCallBack={() => window.location.reload()}
                />

                <div className="mainFlex">
                    <div className={`col2 ${Utils.isEmptyArray(ticketList) && 'border-top'}`}>
                        {Utils.isEmptyArray(ticketList) ? (
                            <div
                                className="listEmpty listEmpty-qa"
                                data-cy="label-ticket-list-empty"
                            >
                                <span className="listEmpty-item">
                                    <img src="/assets/image/icon-listEmpty.svg" alt="" />
                                </span>
                                {trI18n('COMMSG001')}
                            </div>
                        ) : (
                            <ListTicket
                                {...propsForListTicket}
                                API={props?.API}
                                ticketList={ticketList}
                                setTicketList={setTicketList}
                                ticketListType={props.ticketListType}
                                panelType={props.panelType}
                                viewSelectedId={viewSelected?.id}
                                setTriggerSearch={setTriggerSearch}
                                isLoading={isLoading}
                                setIsLoading={setIsLoading}
                                isProjectManager={isProjectManager}
                                projectUserList={projectUserList}
                                panelId={props.panelId}
                                fromTicket={fromTicket}
                                setFromTicket={setFromTicket}
                                lastedCountList={lastedCountList}
                                setLastedCountList={setLastedCountList}
                                inputKeyWordRef={inputKeyWordRef}
                                setSugguestionList={setSugguestionList}
                                sugguestionList={sugguestionList}
                                viewStructure={viewStructure}
                                setViewStructure={setViewStructure}
                                setOptionSearchTime={setOptionSearchTime}
                                defaultDrillDownData={defaultDrillDownData}
                                keywordSearch={keywordSearch}
                                setKeywordSearch={setKeywordSearch}
                                drilldownDataSelected={drilldownDataSelected}
                                setDrillDownDataSelected={setDrillDownDataSelected}
                                isLoadingDrillDown={isLoadingDrillDown}
                                setIsLoadingDrillDown={setIsLoadingDrillDown}
                                setDrillDownData={setDrillDownData}
                                setTotalTickets={setTotalTickets}
                                triggerSearch={triggerSearch}
                                triggerInterval={triggerInterval}
                            />
                        )}
                    </div>
                </div>
            </div>
        );
    };

    /**
     * Handle open phone search popover
     */
    const handleOpenPhoneSearch = async (event) => {
        const anchorEl = event.currentTarget;
        setPhoneSearchAnchorEl(anchorEl);
    };

    /**
     * Handle close phone search popover
     */
    const handleClosePhoneSearch = () => {
        setPhoneSearchAnchorEl(null);
    };

    /**
     * Handle phone selection and make outbound call
     * @param {Object} phoneData - Selected phone data
     */
    const handleSelectPhone = async (phoneData) => {
        // Add sourcePanel for Ticket list
        const phoneDataWithSource = {
            ...phoneData,
            sourcePanel: 'TICKET_LIST'
        };
        
        await initiateCall(phoneDataWithSource);
        handleClosePhoneSearch();
    };

    const handleMakeCallAiTraining = async (aiOperatorTicket) => {
        try {
            // Don't start a new call if one is already in progress
            if (voiceStatus !== Constant.PHONE_AVAILABILITY.READY) return;

            // Validate telephone agent permission before making training call
            const validationResult = await validateTrainingTelephonePermission(
                corporationDetail?.id,
                projectInuseDetail?.id
            );

            if (!validationResult.isValid) {
                setIsShowDialogReload(true);
                return;
            }

            setVoiceStatus(Constant.PHONE_AVAILABILITY.CONNECTING);
            setVoiceCallAiTraining(aiOperatorTicket);

            // Check microphone availability before creating session (which creates a ticket)
            try {
                const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
                stream.getTracks().forEach(t => t.stop());
            } catch (micErr) {
                setVoiceCallAiTraining(null);
                setVoiceStatus(Constant.PHONE_AVAILABILITY.READY);
                return;
            }

            // call Lambda OpenAIWebRTCHandler to create session
            const sessionResult = await openAIWebRTCService.createSession(
                corporationDetail?.id,
                projectInuseDetail?.id,
                userDetail?.id,
                { aiOperatorTicketId: aiOperatorTicket?.id },
            );

            if (!sessionResult?.status) {
                if (sessionResult?.errorCode === Constant.UNSUPPORTED_REALTIME_MODEL_ERROR) {
                    enqueueSnackbar(buildSnackbarMessage('TEL_ERR_UNSUPPORTED_REALTIME_MODEL'), { variant: 'error', autoHideDuration: 5000 });
                    setVoiceCallAiTraining(null);
                    setVoiceStatus(Constant.PHONE_AVAILABILITY.READY);
                    return;
                }
                if (sessionResult?.errorCode === Constant.DATA_CHANGED_PLEASE_RELOAD_ERROR) {
                    setIsShowDialogReload(true);
                    setVoiceCallAiTraining(null);
                    setVoiceStatus(Constant.PHONE_AVAILABILITY.READY);
                    return;
                }
                throw new Error(sessionResult?.errorMsg || 'Failed to create OpenAI session');
            }

            // Session created → update atom with sessionData, keep CONNECTING
            // ActiveCallAiTraining will detect sessionData and initiate WebRTC connection
            // voiceStatus will change to ACTIVE when WebRTC is connected
            setVoiceCallAiTraining(prev => ({
                ...prev,
                sessionData: sessionResult.data?.session || null,
                ticketData: sessionResult.data?.ticket || null,
                aiTrainingChatThreadId: sessionResult.data?.aiTrainingChatThreadId || null,
                greeting: sessionResult.data?.greeting || null,
                // SIF tools call context (CR-2026-005 / TEL-009)
                toolsCallTimeoutSeconds: sessionResult.data?.toolsCallTimeoutSeconds,
                holdMusicUrl: sessionResult.data?.holdMusicUrl || '',
                aiOperatorTicketId: sessionResult.data?.aiOperatorTicketId || aiOperatorTicket?.id || null,
            }));

            // Open ticket detail + chat panel for AI training
            const ticketResult = sessionResult.data?.ticket;
            if (ticketResult?.ticketId) {
                openTelephoneTicketPanel({
                    ticketData: { ticketId: ticketResult.ticketId, chatThreadId: ticketResult.customerChatThreadId },
                    projectInuseDetail,
                    projectList: [],
                    addNewPanel,
                    reloadTicketListByPanelType
                });
            }
        } catch (error) {
            console.log('handleMakeCallAiTraining error >>> ', error);
            setVoiceCallAiTraining(null);
            setVoiceStatus(Constant.PHONE_AVAILABILITY.READY);
        } finally {
            handleClosePhoneSearch();
        }
    }

    const renderListView = () => {
        let listViewShow = listView.filter(x => x.status === Constant.STATUS_VIEW.SHOW);
        let isDisplayNavTabs = listViewShow.length <= Constant.LIST_VIEW_TICKET_HELP_DESK;
        return (
            <div className="navTabs navTabs-flex">
                <div className="navTabs-group">
                    <DialogViewNameError
                        setIsOpenDialogViewNameError={setIsOpenDialogViewNameError}
                        inputViewNameRef={inputViewNameRef}
                        isOpenDialogViewNameError={isOpenDialogViewNameError}
                        viewNameErrorType={viewNameErrorType}
                    />
                    <DialogNoticeViewChanged
                        setIsOpenDialogViewChanged={setIsOpenDialogViewChanged}
                        setIsLoading={setIsLoading}
                        isOpenDialogViewChanged={isOpenDialogViewChanged}
                        userDetail={userDetail}
                        projectInuseDetail={projectInuseDetail}
                        viewStructure={viewStructure}
                        API={API}
                        tabs={listViewShow}
                        viewSelected={viewSelected}
                        setViewSelected={setViewSelected}
                        inputViewNameRef={inputViewNameRef}
                        setViewStructure={setViewStructure}
                        isProjectManager={isProjectManager}
                        listView={listView}
                        setListView={setListView}
                        setTriggerSearch={setTriggerSearch}
                        setIsLoadingView={setIsLoadingView}
                        setViewNameErrorType={setViewNameErrorType}
                        setIsOpenDialogViewNameError={setIsOpenDialogViewNameError}
                        setSettingSlideRecoilState={setSettingSlideRecoilState}
                        setIsInitView={setIsInitView}
                        corporationId={corporationDetail.id}
                        setDefaultDrillDownData={setDefaultDrillDownData}
                    />

                    {/* Render list view helpdesk list */}
                    <ViewHelpDeskList
                        API={API}
                        tabs={listViewShow}
                        viewSelected={viewSelected}
                        setViewSelected={setViewSelected}
                        inputViewNameRef={inputViewNameRef}
                        viewStructure={viewStructure}
                        setViewStructure={setViewStructure}
                        isProjectManager={isProjectManager}
                        listView={listView}
                        setListView={setListView}
                        setTriggerSearch={setTriggerSearch}
                        setIsLoadingView={setIsLoadingView}
                        setIsOpenDialogViewChanged={setIsOpenDialogViewChanged}
                        setViewNameErrorType={setViewNameErrorType}
                        setIsOpenDialogViewNameError={setIsOpenDialogViewNameError}
                        userDetail={userDetail}
                        projectInuseDetail={projectInuseDetail}
                        setSettingSlideRecoilState={setSettingSlideRecoilState}
                        setIsInitView={setIsInitView}
                        setIsOpenModalReloadPage={setIsOpenModalReloadPage}
                    />
                </div>
                <div className="btnTabs-wrap">
                    {!isDisplayNavTabs && (
                        <SeemoreViewHelpdeskList
                            listViewShow={listViewShow}
                            viewSelected={viewSelected}
                            setViewSelected={setViewSelected}
                            viewStructure={viewStructure}
                            setViewStructure={setViewStructure}
                            setTriggerSearch={setTriggerSearch}
                            element={element}
                            nodeListView={nodeListView}
                            getVisibleWidth={getVisibleWidth}
                            setIsOpenModalReloadPage={setIsOpenModalReloadPage}
                            setIsLoadingView={setIsLoadingView}
                        />
                    )}

                    <AddViewHelpdeskList
                        API={API}
                        setIsLoading={setIsLoading}
                        element={element}
                        getVisibleWidth={getVisibleWidth}
                        listView={listView}
                        setListView={setListView}
                        openListViewHide={openListViewHide}
                        setOpenListViewHide={setOpenListViewHide}
                        viewStructure={viewStructure}
                        setViewStructure={setViewStructure}
                        isProjectManager={isProjectManager}
                        userDetail={userDetail}
                        projectInuseDetail={projectInuseDetail}
                        corporationDetail={corporationDetail}
                        setIsOpenDialogViewChanged={setIsOpenDialogViewChanged}
                        viewSelected={viewSelected}
                        setViewSelected={setViewSelected}
                        setIsLoadingView={setIsLoadingView}
                        setTriggerSearch={setTriggerSearch}
                    />

                    {isOpenButtonCreateTicket(
                        userDetail,
                        contractType,
                        props.ticketListType,
                        projectInuseDetail
                    ) && (
                        <>
                            <Tooltip title={tr('新規作成')}>
                                <button
                                    className="btn-add-ticket"
                                    onClick={e => handleOptionsTicketTypeToCreate(e) }
                                >
                                    <img
                                        src="/assets/image/icon-add-ticket.svg"
                                        alt="icon-add-ticket"
                                    />
                                    <span className="text-add-ticket">{tr('作成')}</span>
                                </button>
                            </Tooltip>
                            <Popover
                                className="ticket-types-manager"
                                style={{ width: 'auto' }}
                                id={isOpenFormTypePopover ? 'simple-popover' : undefined}
                                open={isOpenFormTypePopover}
                                anchorEl={formTypePopover}
                                onClose={() => setFormTypePopover(null)}
                                anchorOrigin={{
                                    vertical: 'bottom',
                                    horizontal: 'left'
                                }}
                            >
                                <ul>
                                    {(Utils.isPublicDesk(projectInuseDetail) ||
                                        Utils.isPrivateDesk(projectInuseDetail) || 
                                        Utils.isProjectGuestDesk(projectInuseDetail)) && (
                                        <>
                                            <li
                                                className="active"
                                                onClick={e =>
                                                    handleAddPanel(
                                                        e,
                                                        Constant.HELPDESK_CREATE_TICKET_TYPE.NOTICE
                                                    )
                                                }
                                            >
                                                
                                                <span className="text">
                                                    {trI18n('FIELDFORMBTN008')}
                                                </span>
                                            </li>
                                            <li
                                                onClick={e =>
                                                    handleAddPanel(
                                                        e,
                                                        Constant.HELPDESK_CREATE_TICKET_TYPE
                                                            .DELEGATE
                                                    )
                                                }
                                            >
                                                <span className="text">
                                                    {trI18n('HELPDESK-CREATE-TICKET-DELEGATE')}
                                                </span>
                                            </li>
                                        </>
                                    )}
                                    {Utils.isPublicDesk(projectInuseDetail) && (
                                        <>
                                            <li
                                                onClick={e =>
                                                    handleAddPanel(
                                                        e,
                                                        Constant.HELPDESK_CREATE_TICKET_TYPE
                                                            .INVITATION_GUEST
                                                    )
                                                }
                                            >
                                                
                                                <span className="text">
                                                    {trI18n('HELPDESK-CREATE-TICKET-INVITATION-GUEST')}
                                                </span>
                                            </li>
                                        </>
                                    )}
                                    <li
                                        onClick={e =>
                                            handleAddPanel(
                                                e,
                                                Constant.HELPDESK_CREATE_TICKET_TYPE.TASK
                                            )
                                        }
                                    >
                                        <span className="text">{trI18n('FIELDFORMBTN009')}</span>
                                    </li>
                                    {Utils.isEnableCreateEmailTicketMode(corporationDetail, projectInuseDetail) && (
                                        <>
                                            <li
                                                onClick={e =>
                                                    handleAddPanel(
                                                        e,
                                                        Constant.HELPDESK_CREATE_TICKET_TYPE
                                                            .EMAIL
                                                    )
                                                }
                                            >
                                                
                                                <span className="text">
                                                    {trI18n('HELPDESK-CREATE-TICKET-EMAIL')}
                                                </span>
                                            </li>
                                        </>
                                    )}
                                </ul>
                            </Popover>
                        </>
                    )}

                    {/* Make Call Button */}
                    {Utils.shouldShowPhoneIcon(corporationDetail, projectInuseDetail, props?.ticketListType) && (
                        <Tooltip title={tr('ボイス')}>
                            <button
                                className={`btn-make-call ${isCannotMakeCall ? 'disabled' : ''}`}
                                disabled={isCannotMakeCall}
                                onClick={handleOpenPhoneSearch}
                            >
                                <img src="/assets/image/voice.svg" alt="phone" />
                            </button>
                        </Tooltip>
                    )}

                    {/* Phone Search Popover */}
                    <PhoneSearchPopoverV2
                        open={isPhoneSearchOpen}
                        anchorEl={phoneSearchAnchorEl}
                        onClose={handleClosePhoneSearch}
                        onSelectPhone={handleSelectPhone}
                        onMakeCallAiTraining={handleMakeCallAiTraining}
                    />
                </div>
            </div>
        );
    };

    return (
        <div className="mainWrap">
            <LoadingPanel isLoading={isLoading || isLoadingView} />
            <div className="customMainTop">{renderListView()}</div>

            <div className="contentTab">{renderContentTab()}</div>

            <DataChangePleaseReloadModal
                isOpen={isOpenModalReloadPage}
                setIsOpen={setIsOpenModalReloadPage}
            />
            <ConfirmDialog
                isOpen={isShowDialogNotiLimit}
                msgConfirm={trI18n('MSG-CM-EXCEED-MAX-CONTENT-BULK-ACTION')}
                okCallBack={() => setIsShowDialogNotiLimit(false)}
            />
        </div>
    );
}
